/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedPilotDetails } from '../../models/created-pilot-details';

export interface GetPilots$Params {
  active: boolean;
}

export function getPilots(http: HttpClient, rootUrl: string, params: GetPilots$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CreatedPilotDetails>>> {
  const rb = new RequestBuilder(rootUrl, getPilots.PATH, 'get');
  if (params) {
    rb.query('active', params.active, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CreatedPilotDetails>>;
    })
  );
}

getPilots.PATH = '/pilots';
